const updateItem = (state, item) => replaceItem(state, {
  ...state.collectionById[(item.id || item._id)],
  ...item
})

const replaceItem = (state, item) => (state.collectionById = {
  ...state.collectionById,
  [(item.id || item._id)]: item
})

const updateCollection = (state, collection) => (state.collectionById = {
  ...state.collectionById,
  ...collection.reduce((accumulator, item) => {
    accumulator[(item.id || item._id)] = item
    return accumulator
  }, {})
})

export default {
  state: {
    collectionById: {}
  },
  getters: {
    collection: state => state.collectionById
  },
  mutations: {
    updateItem: (state, { item }) => updateItem(state, item),
    replaceItem: (state, { item }) => replaceItem(state, item),
    updateCollection: (state, { collection }) => updateCollection(state, collection)
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/helpers/collection.js